<template src="./StopWords.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import SearchQuery from "@/components/suppliers/components/SearchQuery"
import TopMenu from "@/components/suppliers/components/topMenu"

const {mapGetters, mapActions} = createNamespacedHelpers('suppliers/stopWords');

export default {
  name: "SuppliersStopWords",
  components: {
    SearchQuery,
    TopMenu,
  },
  data() {
    return {
      showOverlay: false,
      keys: {},
      langList: ['en'],
      currentLang: 'en',
      timer: null,
    }
  },
  methods: {
    ...mapActions(['SAVE', 'GET_DATA']),
    keysChange() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.SAVE({th: this})
      }, 1500)
    },
    getData() {
      this.GET_DATA({th: this})
    },
    prepareValue() {
      // do initial fill STOP_WORDS if it empty
      for (let key in this.langList) {
        let lang = this.langList[key]
        if (this.STOP_WORDS[lang] === undefined || Object.keys(this.STOP_WORDS[lang]).length === 0) {
          this.keys[lang] = []
        } else {
          this.keys[lang] =this.STOP_WORDS[lang].slice(0)
        }
      }

      this.$store.commit('suppliers/stopWords/STOP_WORDS', Object.assign({}, this.keys))
    },
  },
  computed: {
    ...mapGetters([
      'STOP_WORDS',
    ]),
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('suppliers') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>